import { Component, ErrorInfo, ReactNode } from "react";
import "./ErrorBoundary.css";
import ErrorFallback from "./ErrorFallback";

interface ErrorBoundaryProps {
    children?: ReactNode;
}

interface ErrorBoundaryState {
    hasError: boolean;
    error: Error;
    errorInfo: ErrorInfo;
}

export default class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
    constructor(props: ErrorBoundaryProps) {
        super(props);
        this.state = { hasError: false, error: { message: "", name: "", cause: "", stack: "" } as Error, errorInfo: { componentStack: "" } as ErrorInfo };
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        this.setState({ hasError: true, error, errorInfo });
    }

    resetErrorBoundaryState() {
        this.setState({ hasError: false, error: { message: "", name: "", cause: "", stack: "" } as Error, errorInfo: { componentStack: "" } as ErrorInfo });
    }

    render() {
        if (this.state.hasError) {
            return <ErrorFallback error={this.state.error} errorInfo={this.state.errorInfo} resetErrorBoundaryState={() => this.resetErrorBoundaryState()} />;
        }

        return <>{this.props.children}</>;
    }
}
